<template>
  <div class="upgrade-label" :class="[size, package]">
    <span>Upgrade</span>
    <div class="upgrade-label__icon">
      <LucideIcon icon="Zap"/>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'UpgradeElement',
  props: {
    size: {
      type: String as PropType<'sm' | 'lg'>,
      default: 'sm'
    },
    package: {
      type: String as PropType<'pro' | 'bus'>,
      default: 'pro'
    }
  },
  computed: {
    alignmentClass(): string {
      return this.alignment === 'sm' ? 'sm' : 'lg';
    }
  }
})
</script>


<style lang="scss" scoped>
.upgrade-label {
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  background-color: var(--light-100);
  border-radius: $br-xs;
  color: var(--orange-30);
  box-shadow: var(--shadow-xs-orange);
  font-size: var(--fs-12);
  font-weight: 600;
  line-height: 20px;
  max-height: 22px;

  &__icon{
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--text-light-fixed);
    background: var(--orange-100);
    border-radius: $br-sm;
    font-size: var(--fs-12);
    line-height: normal;
  }

  /* small */
  &.sm{
    padding: var(--space-1);
    border-radius: $br-sm;
    span{
      display: none;
    }
    .icon{
      margin-left:  var(--space-0);
    }
  }

  /* business */
  &.bus{
    background-color: var(--light-100);
    box-shadow: var(--shadow-xs-teal);
    .upgrade-label__icon{
      background:  var(--teal-100);
    }
  }
}
</style>
